import { Controller } from "@hotwired/stimulus"

// Guards the manual "zapłacono dotychczas" form, where the paid amount is
// typed as two parts — netto and VAT. Keeps the "Razem" line in sync with
// them, and when their sum falls below what bank-sent paczki przelewów
// already transferred, the server requires an explicit confirmation param —
// this controller asks via window.confirm and stamps the hidden field before
// the form submits. Also powers the "wyzeruj" / "tylko netto" / "całość"
// quick-fill buttons.
export default class extends Controller {
  static targets = ["net", "vat", "total", "confirmed"]
  static values = { floorCents: Number, floorLabel: String, symbol: String }

  connect() {
    this.recalc()
  }

  recalc() {
    const cents = this.#totalCents()
    this.totalTarget.textContent = cents === null ? "—" : this.#format(cents)
  }

  submit(event) {
    const cents = this.#totalCents()
    if (cents === null || cents >= this.floorCentsValue) return

    const message =
      `Paczki przelewów wysłane do banku pokrywają już ${this.floorLabelValue}. ` +
      `Ustawiasz mniejszą kwotę.\n\nKontynuować?`
    if (confirm(message)) {
      this.confirmedTarget.value = "1"
    } else {
      event.preventDefault()
    }
  }

  fill(event) {
    this.netTarget.value = event.params.net
    this.vatTarget.value = event.params.vat
    this.recalc()
    this.netTarget.focus()
  }

  // null when either field is unparseable — the server rejects that input, so
  // the confirm dialog stays out of the way and lets the error through.
  #totalCents() {
    const net = this.#parseCents(this.netTarget.value)
    const vat = this.#parseCents(this.vatTarget.value)
    return net === null || vat === null ? null : net + vat
  }

  #parseCents(raw) {
    const normalized = raw.replace(/\s/g, "").replace(",", ".")
    const value = Number.parseFloat(normalized)
    return Number.isFinite(value) ? Math.round(value * 100) : null
  }

  #format(cents) {
    const amount = (cents / 100).toFixed(2).replace(".", ",")
    return `${amount} ${this.symbolValue}`
  }
}
